//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';

export default {
    state: {
        stageCostMass: [],
        searchRequest: null,
      },

      mutations: {
        updatestageCostMass(state, list) {
          state.stageCostMass = list;
        },
        updateSearchstageCostMassRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },

      actions: {
        async stageCostMass({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest))


 
          if (requestToSend.billingDate.startDate)
          {
              const date = moment(requestToSend.billingDate.startDate)
                          .endOf('d')
                          .toDate();
              console.log(date)
              console.log(date.getMonth())
              console.log(date.getDate())
              var month = (date.getMonth() + 1).toString()
              if (month.length === 1)
              {
                  month = '0' + month
              }
      
              var day = date.getDate().toString()
              if (day.length === 1)
              {
                  day = '0' + day
              }
              requestToSend.billingDate.startDate = date.getFullYear() + '-' + month + '-' + day
          }
      
          if (requestToSend.billingDate.endDate)
          {
              const date = moment(requestToSend.billingDate.endDate)
                          .endOf('d')
                          .toDate();
      
                          var month = (date.getMonth() + 1).toString()
                          if (month.length == 1)
                          {
                              month = '0' + month
                          }
                  
                          var day = date.getDate().toString()
                          if (day.length == 1)
                          {
                              day = '0' + day
                          }
              requestToSend.billingDate.endDate = date.getFullYear() + '-' + month + '-' + day
          }
          else
          {
            if (requestToSend.billingDate.startDate != null)
            {
              const date = moment(requestToSend.billingDate.startDate)
                          .endOf('d')
                          .toDate();
              console.log(date)
              console.log(date.getMonth())
              console.log(date.getDate())
              var month = (date.getMonth() + 1).toString()
              if (month.length === 1)
              {
                  month = '0' + month
              }
      
              var day = date.getDate().toString()
              if (day.length === 1)
              {
                  day = '0' + day
              }
      
              requestToSend.billingDate.endDate = date.getFullYear() + '-' + month + '-' + day
            }
              
          }



          console.log(requestToSend);


        const st = performance.now();
        //const result = await api.post('/api/w/apar/listStage', requestToSend);
        const result = await newAPIPost('/api/w/apar/listStage', requestToSend);
        commit('updateSearchstageCostMassRequest', fallbackRequest);
        console.log(JSON.stringify(result));
        return commit('updatestageCostMass', result);
            
        },
      },


      getters: {
        getstageCostMass: state => state.stageCostMass,
      },
}